module.exports = __webpack_public_path__ + "static/SaltStack_Comply_white-61764281b75b398fda04a0dec0f3f133.png";